import styled from 'styled-components'
import { colors } from '../../../theme'

export const Topo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`

export const BotaoVoltar = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  background-color: ${colors.grey100};
  border: none;
  cursor: pointer;
  border-radius: 9px;
`

export const TituloPagina = styled.h1`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 22px;
  color: ${colors.grey900};
  margin: 0;
`

export const Badge = styled.span<{ ativo: boolean }>`
  margin-left: 10px;
  padding: 4px 12px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ ativo }) => (ativo ? colors.secondaryText : colors.errorText)};
  background-color: ${({ ativo }) =>
    ativo ? colors.lightGreen : colors.lightRed};
`

export const Secao = styled.section`
  background-color: ${colors.surface};
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.28);
  border-radius: 24px;
  padding: 24px 30px;
  margin-bottom: 20px;
`

export const TituloSecao = styled.h2`
  font-family: 'Poppins';
  font-weight: 600;
  font-size: 16px;
  color: ${colors.grey900};
  margin: 0 0 6px 0;
`

export const DescricaoSecao = styled.p`
  font-size: 12px;
  color: ${colors.grey600};
  margin: 0 0 20px 0;
`

export const LinhaCampos = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
`

export const Campo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  span {
    color: ${colors.errorText};
    font-size: 13px;
  }
`

export const Rotulo = styled.label`
  font-size: 12px;
  color: ${colors.grey700};
`

export const Entrada = styled.input<{ largura?: string }>`
  width: ${({ largura }) => largura || '320px'};
  max-width: 100%;
  height: 44px;
  border: 1px solid ${colors.grey300};
  border-radius: 12px;
  font-size: 14px;
  padding: 0 14px;

  &:disabled {
    background-color: ${colors.grey100};
    color: ${colors.grey600};
    cursor: not-allowed;
  }
`

export const Dica = styled.small`
  color: ${colors.grey600};
  font-size: 11px;
  line-height: 1.25;
  max-width: 340px;
`

// Variante em bloco da Dica, para uso FORA de um <Campo>. `Dica` é <small>, portanto inline:
// solta dentro da <Secao> ela não quebra linha e ignora o max-width, e várias em sequência
// saem coladas num parágrafo corrido.
export const BlocoDica = styled(Dica)`
  display: block;
  max-width: 640px;

  & + & {
    margin-top: 6px;
  }
`

// Trilha de declarações anteriores do marco zero. Lista, e não texto separado por ";": com 3+
// declarações o corrido vira um bloco ilegível, e cada linha carrega autor e carimbo.
export const ListaHistorico = styled.ul`
  color: ${colors.grey600};
  font-size: 11px;
  line-height: 1.5;
  margin: 6px 0 0;
  padding-left: 18px;
`

// Moldura do preview da logo. Fundo xadrez para que uma logo com transparência
// (o caso comum de PNG) não se confunda com a superfície do cartão. Os dois tons
// do xadrez são vizinhos de propósito: em branco/quase-preto o damero competiria
// com a própria logo em vez de servir de fundo neutro.
export const LogoPreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 90px;
  padding: 8px;
  border: 1px dashed ${colors.grey300};
  border-radius: 12px;
  background-color: ${colors.grey100};
  background-image: linear-gradient(
      45deg,
      ${colors.grey300} 25%,
      transparent 25%
    ),
    linear-gradient(-45deg, ${colors.grey300} 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, ${colors.grey300} 75%),
    linear-gradient(-45deg, transparent 75%, ${colors.grey300} 75%);
  background-size: 16px 16px;
  background-position: 0 0, 0 8px, 8px -8px, -8px 0px;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`

export const LogoVazio = styled.span`
  font-size: 12px;
  color: ${colors.grey600};
  text-align: center;
`

export const LinhaLogo = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
`

export const EntradaArquivo = styled.input`
  font-size: 13px;
  max-width: 320px;
`

export const ErroLogo = styled.span`
  display: block;
  margin-top: 12px;
  color: ${colors.errorText};
  font-size: 13px;
`

export const LinhaSwitch = styled.div`
  margin: 20px 0 0 0;
`

export const Botoes = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
`

export const Botao = styled.button<{ variante?: 'primario' | 'secundario' }>`
  cursor: pointer;
  min-width: 200px;
  height: 44px;
  padding: 0 20px;
  border-radius: 16px;
  font-size: 14px;
  border: 1px solid
    ${({ variante }) =>
      variante === 'secundario' ? colors.secondary : 'transparent'};
  background-color: ${({ variante }) =>
    variante === 'secundario' ? 'transparent' : colors.accentBg};
  color: ${({ variante }) =>
    variante === 'secundario' ? colors.secondaryText : colors.white};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`
